import { API_BASE_URL, fetchAuthenticated } from "../utils/config";

// "Aluma Care Missouri LLC" -> "AM". Legal suffixes carry no identity, and we
// take the FIRST and LAST remaining words rather than the first two: related
// companies usually share a prefix ("Aluma Care X"), so first-two would render
// the same initials for every one of them.
const initialsFor = (name = "") => {
  const skip = new Set(["llc", "inc", "co", "corp", "ltd", "the"]);
  const clean = (w) => w.toLowerCase().replace(/[.,]/g, "");
  const words = name.split(/\s+/).filter((w) => w && !skip.has(clean(w)));
  const source = words.length ? words : name.split(/\s+/).filter(Boolean);
  if (!source.length) return "?";
  const first = source[0][0];
  const last = source.length > 1 ? source[source.length - 1][0] : "";
  return (first + last).toUpperCase();
};

function ProfileInfo({ accounts, onRemove, onReconnect }) {
  const handleRemoveCompany = async (accountId, companyName) => {
    if (
      !window.confirm(
        `Remove ${companyName}?\n\nIts data will no longer appear in your reports.`
      )
    )
      return;

    try {
      const res = await fetchAuthenticated(
        `${API_BASE_URL}/companyProfile/removeCompany`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ accountId }),
        }
      );

      if (!res.ok) throw new Error("Failed to remove company");

      // Notify parent to refresh account list
      if (onRemove) onRemove(accountId);
    } catch (err) {
      console.error("Error removing company:", err);
      alert("Failed to remove company. Please try again.");
    }
  };

  if (!accounts.length)
    return <p className="muted">No connected accounts found.</p>;

  return (
    <div className="company-grid">
      {accounts.map((acc) => {
        const expired = acc.active === false;

        return (
          <div
            key={acc.accountId}
            className={`company-card${expired ? " is-expired" : ""}`}
          >
            <div className="company-avatar" aria-hidden="true">
              {initialsFor(acc.companyName)}
            </div>

            <div className="company-main">
              <p className="company-name" title={acc.companyName}>
                {acc.companyName}
              </p>

              <div className="company-meta">
                {/* Dot plus written label: state never rests on color alone */}
                <span
                  className={`status ${
                    expired ? "status--critical" : "status--good"
                  }`}
                >
                  <span className="status-dot" />
                  {expired ? "Connection expired" : "Connected"}
                </span>

                {acc.groupName && acc.groupName !== "Ungrouped" && (
                  <span className="group-tag" title={acc.groupName}>
                    {acc.groupName}
                  </span>
                )}
              </div>
            </div>

            <div className="company-actions">
              {expired && onReconnect && (
                <button
                  type="button"
                  className="btn btn-neutral btn-sm"
                  onClick={onReconnect}
                >
                  Reconnect
                </button>
              )}
              <button
                type="button"
                className="icon-btn"
                onClick={() =>
                  handleRemoveCompany(acc.accountId, acc.companyName)
                }
                title={`Remove ${acc.companyName}`}
                aria-label={`Remove ${acc.companyName}`}
              >
                ✕
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ProfileInfo;
